import React from 'react';
import { connect } from "react-redux";

import {
  setMasonryJobSiteTestConstructionWork,
  setMasonryJobSiteTestBuildingOwner,
  setMasonryJobSiteTestDateOfTests,
  setMasonryJobSiteTestPlaceOfTests,
  setMasonryJobSiteTestTypeOfStructureToBeFixed
} from '@reducers/selectors/material/actions';
import { APP_TEXTS } from '../../../../../../../../texts/texts';

// eslint-disable-next-line react/prefer-stateless-function
class ResultsTable extends React.Component {

  render() {
    return (
      <div className="ml-2 mr-2">
        <label htmlFor="construction-work" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.CONSTRUCTION_WORK_LABEL.Content}</span>
          <input className="form-control col-5" type="text" id="construction-work"
                 value={this.props.constructionWork}
                 onChange={({ target }) => this.props.setConstructionWork(target.value)}
          />
        </label>

        <label htmlFor="building-owner" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.BUILDING_OWNER_LABEL.Content}</span>
          <input className="form-control col-5" type="text" id="building-owner"
                 value={this.props.buildingOwner}
                 onChange={({ target }) => this.props.setBuildingOwner(target.value)}
          />
        </label>

        <label htmlFor="date-of-tests" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.DATE_OF_TESTS_LABEL.Content}</span>
          <input className="form-control col-5" type="text" id="date-of-tests"
                 value={this.props.dateOfTests}
                 onChange={({ target }) => this.props.setDateOfTests(target.value)}
          />
        </label>

        <label htmlFor="place-of-tests" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.PLACE_OF_TESTS_LABEL.Content}</span>
          <input className="form-control col-5" type="text" id="place-of-tests"
                 value={this.props.placeOfTests}
                 onChange={({ target }) => this.props.setPlaceOfTests(target.value)}
          />
        </label>

        <label htmlFor="type-of-structure-to-be-fixed" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.TYPE_OF_STRUCTURE_LABEL.Content}</span>
          <input className="form-control col-5" type="text" id="type-of-structure-to-be-fixed"
                 value={this.props.typeOfStructureToBeFixed}
                 onChange={({ target }) => this.props.setTypeOfStructureToBeFixed(target.value)}
          />
        </label>
      </div>
    );
  }

}

const mapState = state => ({
  constructionWork: state.selectors.material[state.main.appType].masonry.jobSiteTest.details.constructionWork,
  buildingOwner: state.selectors.material[state.main.appType].masonry.jobSiteTest.details.buildingOwner,
  dateOfTests: state.selectors.material[state.main.appType].masonry.jobSiteTest.details.dateOfTests,
  placeOfTests: state.selectors.material[state.main.appType].masonry.jobSiteTest.details.placeOfTests,
  typeOfStructureToBeFixed: state.selectors.material[state.main.appType].masonry.jobSiteTest.details.typeOfStructureToBeFixed,
});

const mapDispatch = dispatch => ({
  setConstructionWork: value => dispatch(setMasonryJobSiteTestConstructionWork(value)),
  setBuildingOwner: value => dispatch(setMasonryJobSiteTestBuildingOwner(value)),
  setDateOfTests: value => dispatch(setMasonryJobSiteTestDateOfTests(value)),
  setPlaceOfTests: value => dispatch(setMasonryJobSiteTestPlaceOfTests(value)),
  setTypeOfStructureToBeFixed: value => dispatch(setMasonryJobSiteTestTypeOfStructureToBeFixed(value)),
});

export default connect(mapState, mapDispatch)(ResultsTable);



// WEBPACK FOOTER //
// ./src/views/Material/components/Masonry/components/JobSiteTest/components/DetailsFields/index.js